module.exports = __webpack_public_path__ + "static/media/tools.2c40749b.png";